// Marketing-specific features and options
export const TARGET_AUDIENCES = {
  b2b: "B2B Decision Makers",
  b2c: "General Consumers",
  enterprise: "Enterprise Leaders",
  smb: "Small Business Owners",
  technical: "Technical Professionals",
  millennials: "Millennial Consumers",
  genZ: "Gen Z Digital Natives",
  executives: "C-Suite Executives",
} as const;

export const CONTENT_GOALS = {
  awareness: "Brand Awareness",
  consideration: "Product Consideration",
  conversion: "Direct Conversion",
  loyalty: "Customer Loyalty",
  thought_leadership: "Thought Leadership",
  lead_generation: "Lead Generation",
  education: "Product Education",
} as const;

export const CTA_TYPES = {
  soft: "Soft CTA (Subscribe, Learn More)",
  medium: "Medium CTA (Free Trial, Download)",
  hard: "Hard CTA (Buy Now, Sign Up)",
  consultation: "Book Consultation",
  demo: "Request Demo",
} as const;

export const COMPETITOR_ANGLES = {
  direct: "Direct Competitor Comparison",
  indirect: "Indirect Alternative Solutions",
  industry: "Industry Transformation",
  innovation: "Innovation Leadership",
  value: "Value Proposition Focus",
} as const;